import script from "./CreatingEmail.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreatingEmail.vue?vue&type=script&setup=true&lang=ts"

import "./CreatingEmail.vue?vue&type=style&index=0&id=398f3798&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-398f3798"]])

export default __exports__